import {
  LdapSearchDataApi,
  LdapSearchItem as LdapSearchItemGenerated,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import LdapItem from '../model/LdapItem';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new LdapSearchDataApi(apiConfiguration(pripomienkyPrefixPath));

const mapLdapItem = (generated: LdapSearchItemGenerated): LdapItem => ({
  uuid: generated.uuid,
  fullName: generated.fullName,
  shortName: generated.shortName,
});

export const getPouzivatelskaSkupinaBySearchToken = async (
  type: string,
  year: number,
  index: number,
  searchTokens: string,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<LdapItem[]>> => {
  const {
    data,
    status,
  } = await client.getPouzivatelskaSkupinaBySearchToken(type, year, index, searchTokens, options);
  return {
    data: data.map(skupina => mapLdapItem(skupina)), responseCode: status,
  };
};

export const getPouzivatelListBySearchToken = async (
  type: string,
  year: number,
  index: number,
  searchTokens: string,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<LdapItem[]>> => {
  const {
    data,
    status,
  } = await client.getPouzivatelListBySearchToken(type, year, index, searchTokens, options);
  return {
    data: data.map(pouzivatel => mapLdapItem(pouzivatel)), responseCode: status,
  };
};
